// extracted by mini-css-extract-plugin
export const iconTextContainer = "icon-text-module--icon-text-container--1srCe";
export const icon = "icon-text-module--icon--1yDmI";
export const iconContent = "icon-text-module--icon-content--1WXcs";
export const huge = "icon-text-module--huge--EI790";
export const big = "icon-text-module--big--1HmSc";
export const large = "icon-text-module--large--9LLf3";
export const small = "icon-text-module--small--5V1Q8";
export const iconHeader = "icon-text-module--icon-header--2MnJa";